/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-08-12T15:42:30.835
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'report-reportrentcontractcard-'

export default 
{
path: '/report/reportrentcontractcard',
name: 'report-reportrentcontractcard',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}reportrentcontractcard-index',

meta:{
...meta,
title: '合同卡券'
},

component: () => import('@/pages/report/reportrentcontractcard/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}reportrentcontractcard-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '合同卡券编辑'
},

component: () => import('@/pages/report/reportrentcontractcard/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}reportrentcontractcarddetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '合同卡券新增'
},

component: () => import('@/pages/report/reportrentcontractcard/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}reportrentcontractcardView',
auth: [
'hidden'
],

meta:{
...meta,
title: '合同卡券详情查看'
},

component: () => import('@/pages/report/reportrentcontractcard/detail-view') ,
},
]
};
